(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~pagination~table"],{

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/components/pagination/constant.js
var MIN_PAGER_COUNT = 4;
var DEFAULT_PAGER_COUNT = 5;
var DEFAULT_PAGE_SIZES = [10, 20, 30, 40, 50, 100];
// CONCATENATED MODULE: ./src/components/pagination/mixins.js

var pagerCountMixin = {
  props: {
    pagerCount: {
      type: Number,
      default: MIN_PAGER_COUNT,
      validator: function validator(value) {
        return value >= MIN_PAGER_COUNT;
      }
    }
  }
};
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(6);

// CONCATENATED MODULE: ./src/components/pagination/prev.jsx

var Prev = {
  name: 'Prev',
  props: {
    disabled: utils["d" /* vueTypes */].bool
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("button", {
      attrs: {
        type: "button",
        disabled: this.disabled
      },
      "class": "btn-prev",
      on: {
        "click": this.onClick
      }
    }, [h("meg-icon", {
      attrs: {
        name: "megui-left"
      }
    })]);
  }
};
/* harmony default export */ var prev = (Prev);
// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/pagination/pagers.jsx




var Pagers = {
  name: 'Pagers',
  mixins: [pagerCountMixin],
  props: {
    disabled: utils["d" /* vueTypes */].bool,
    currentPage: utils["d" /* vueTypes */].number,
    pageCount: utils["d" /* vueTypes */].number,
    pagerCount: utils["d" /* vueTypes */].number
  },
  data: function data() {
    return {
      showPrevMore: false,
      showNextMore: false,
      showLeftPageTurn: false,
      showRightPageTurn: false
    };
  },
  computed: {
    pagers: function pagers() {
      var pageArray = [];
      var realPagerCount = this.pagerCount;
      var isShowMore = true;

      if (this.pageCount <= MIN_PAGER_COUNT) {
        for (var i = 2; i < this.pageCount; ++i) {
          pageArray.push(this.renderPagerBtn(i));
        }

        this.showNextMore = false;
        this.showPrevMore = false;
        return pageArray;
      }

      if (isNaN(this.pagerCount)) {
        realPagerCount = DEFAULT_PAGER_COUNT;
      } else if (this.pagerCount >= this.pageCount) {
        realPagerCount = this.pageCount;
        isShowMore = false;
      }

      realPagerCount = Math.max(realPagerCount, DEFAULT_PAGER_COUNT);
      var midOffset = Math.floor((realPagerCount - 2) / 2);
      var sideOffset = realPagerCount % 2 === 0 ? midOffset - 1 : midOffset;
      var firstShowPrevPos = realPagerCount - sideOffset;
      var firstHideNextPos = this.pageCount - realPagerCount + sideOffset + 1;

      if (this.currentPage < firstShowPrevPos) {
        var _i = 2;
        var count = realPagerCount - 1;

        for (; _i <= count; ++_i) {
          pageArray.push(this.renderPagerBtn(_i));
        }

        this.showPrevMore = false;
        this.showNextMore = _i <= this.pageCount - 1 && isShowMore;
      } else if (this.currentPage > firstHideNextPos) {
        var start = firstHideNextPos - sideOffset + 1;

        for (var _i2 = start; _i2 < this.pageCount; ++_i2) {
          pageArray.push(this.renderPagerBtn(_i2));
        }

        this.showPrevMore = firstHideNextPos > 2 && isShowMore;
        this.showNextMore = false;
      } else {
        for (var _i3 = this.currentPage - midOffset; _i3 <= this.currentPage + midOffset; ++_i3) {
          pageArray.push(this.renderPagerBtn(_i3));
        }

        this.showPrevMore = true;
        this.showNextMore = true;
      }

      return pageArray;
    }
  },
  methods: {
    renderPagerBtn: function renderPagerBtn(pageNum) {
      var h = this.$createElement;
      return h("button", {
        key: "pager".concat(pageNum),
        attrs: {
          disabled: this.disabled
        },
        "class": external_classnames_default()({
          active: this.currentPage === pageNum
        }),
        on: {
          "click": this.onPageClick
        }
      }, [pageNum]);
    },
    onPageClick: function onPageClick(e) {
      var newPage = Number(e.target.textContent);

      if (this.currentPage !== newPage) {
        this.$emit('page-change', newPage);
        this.showLeftPageTurn = false;
        this.showRightPageTurn = false;
      }
    },
    onMoreMouseEnter: function onMoreMouseEnter(isLeft) {
      if (this.disabled) {
        return;
      }

      if (isLeft) {
        this.showLeftPageTurn = true;
      } else {
        this.showRightPageTurn = true;
      }
    },
    onMoreMouseLeave: function onMoreMouseLeave(isLeft) {
      if (this.disabled) {
        return;
      }

      if (isLeft) {
        this.showLeftPageTurn = false;
      } else {
        this.showRightPageTurn = false;
      }
    },
    onPageTurnClick: function onPageTurnClick(isLeft) {
      if (this.disabled) {
        return;
      }

      var newPage = 1;

      if (isLeft) {
        newPage = this.currentPage - this.pagerCount;
        newPage = newPage < 1 ? 1 : newPage;
        this.showRightPageTurn = false;
      } else {
        newPage = this.currentPage + this.pagerCount;
        newPage = newPage > this.pageCount ? this.pageCount : newPage;
        this.showLeftPageTurn = false;
      }

      this.$emit('page-change', newPage);
    },
    renderMore: function renderMore(direction) {
      var h = this.$createElement;
      var isLeft = direction === 'left';
      var isShowPageTrun = isLeft && this.showLeftPageTurn || !isLeft && this.showRightPageTurn;
      return h("div", {
        on: {
          "mouseenter": this.onMoreMouseEnter.bind(this, isLeft),
          "mouseleave": this.onMoreMouseLeave.bind(this, isLeft),
          "click": this.onPageTurnClick.bind(this, isLeft)
        },
        "class": external_classnames_default()("meg-pager-more meg-pager-more-" + direction, {
          disabled: this.disabled
        })
      }, [isShowPageTrun || h("span", ["\xB7\xB7\xB7"]), isShowPageTrun && h("meg-icon", {
        "class": "meg-pager-more-turn",
        attrs: {
          name: "megui-right-loading"
        }
      })]);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": "meg-pager"
    }, [this.renderPagerBtn(1), this.showPrevMore && this.renderMore('left'), this.pagers.map(function (item) {
      return item;
    }), this.showNextMore && this.renderMore('right'), this.pageCount > 1 && this.renderPagerBtn(this.pageCount)]);
  }
};
/* harmony default export */ var pagination_pagers = (Pagers);
// CONCATENATED MODULE: ./src/components/pagination/next.jsx

var Next = {
  name: 'Next',
  props: {
    disabled: utils["d" /* vueTypes */].bool
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("button", {
      attrs: {
        type: "button",
        disabled: this.disabled
      },
      "class": "btn-next",
      on: {
        "click": this.onClick
      }
    }, [h("meg-icon", {
      attrs: {
        name: "megui-right"
      }
    })]);
  }
};
/* harmony default export */ var next = (Next);
// CONCATENATED MODULE: ./src/components/pagination/sizes.jsx


var Sizes = {
  name: 'Sizes',
  props: {
    disabled: utils["d" /* vueTypes */].bool,
    pageSizes: utils["d" /* vueTypes */].array.def(DEFAULT_PAGE_SIZES),
    pageSize: utils["d" /* vueTypes */].number.def(10),
    contentLocale: utils["d" /* vueTypes */].object
  },
  data: function data() {
    return {
      internalPageSize: this.pageSize,
      internalPageSizes: this.calcPageSizes(this.pageSizes)
    };
  },
  methods: {
    calcPageSizes: function calcPageSizes(val) {
      var _this = this;

      var tmpSizes = val && val.length ? val : DEFAULT_PAGE_SIZES;
      this.$nextTick(function () {
        _this.internalPageSize = _this.calcPageSize(tmpSizes);
      });
      return tmpSizes;
    },
    calcPageSize: function calcPageSize(pageSizes) {
      return pageSizes.includes(this.pageSize) ? this.pageSize : pageSizes[0];
    },
    handleChange: function handleChange(size) {
      this.internalPageSize = size;
      this.$emit('change', size);
    }
  },
  watch: {
    pageSizes: function pageSizes(val) {
      this.internalPageSizes = this.calcPageSizes(val);
    },
    pageSize: function pageSize(val) {
      this.internalPageSize = val;
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    return h("meg-select", {
      attrs: {
        disabled: this.disabled,
        value: this.internalPageSize
      },
      "class": "meg-pagination-sizes",
      on: {
        "change": this.handleChange
      }
    }, [this.internalPageSizes && this.internalPageSizes.map(function (item, index) {
      return h("meg-select-option", {
        attrs: {
          value: item
        },
        key: "".concat(item).concat(index)
      }, ["".concat(item).concat(_this2.contentLocale.size)]);
    })]);
  }
};
/* harmony default export */ var sizes = (Sizes);
// CONCATENATED MODULE: ./src/components/pagination/jumper.jsx


var jumper_Prev = {
  name: 'Jumper',
  props: {
    disabled: utils["d" /* vueTypes */].bool,
    contentLocale: utils["d" /* vueTypes */].object
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    onInput: function onInput(evt) {
      var reg = /^[\d]$/;

      if (!reg.test(evt.data)) {
        evt.target.value = evt.target.value.substring(0, evt.target.value.length - 1);
      }
    },
    onKeyPress: function onKeyPress(evt) {
      var val = evt.target.value.trim(); // enter

      if (evt.keyCode === 13 && val) {
        this.$emit('ok', parseInt(val, 10));
        evt.target.value = '';
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var locale = this.contentLocale;
    return h("div", {
      "class": external_classnames_default()('meg-pagination-jumper', {
        'disabled': this.disabled
      })
    }, [locale.goTo, h("input", {
      attrs: {
        disabled: this.disabled
      },
      on: {
        "keypress": this.onKeyPress,
        "input": this.onInput
      }
    }), locale.page]);
  }
};
/* harmony default export */ var jumper = (jumper_Prev);
// CONCATENATED MODULE: ./src/components/pagination/total.jsx


var Total = {
  name: 'Total',
  props: {
    disabled: utils["d" /* vueTypes */].bool,
    total: utils["d" /* vueTypes */].number.def(0),
    contentLocale: utils["d" /* vueTypes */].object
  },
  render: function render() {
    var h = arguments[0];
    var locale = this.contentLocale;
    return h("span", {
      "class": external_classnames_default()('meg-pagination-total', {
        'disabled': this.disabled
      })
    }, [locale.total, " ", this.total, " ", locale.items]);
  }
};
/* harmony default export */ var total = (Total);
// EXTERNAL MODULE: ./src/base/locale-provider/LocaleReceiver.jsx
var LocaleReceiver = __webpack_require__(15);

// CONCATENATED MODULE: ./src/components/pagination/pagination.jsx








 // 样式文件
// import './style/index.scss';


var MegPagination = {
  name: 'MegPagination',
  mixins: [pagerCountMixin],
  props: {
    pageSize: utils["d" /* vueTypes */].number.def(10),
    total: utils["d" /* vueTypes */].number.def(0),
    currentPage: utils["d" /* vueTypes */].number.def(1),
    pageCount: utils["d" /* vueTypes */].number,
    pagerCount: utils["d" /* vueTypes */].number.def(7),
    disabled: utils["d" /* vueTypes */].bool,
    size: utils["d" /* vueTypes */].oneOf(['small', 'default']).def('default'),
    pageSizes: utils["d" /* vueTypes */].array.def([10, 20, 30, 40, 50, 100]),
    showSizes: utils["d" /* vueTypes */].bool,
    showJumper: utils["d" /* vueTypes */].bool,
    showTotal: utils["d" /* vueTypes */].bool
  },
  data: function data() {
    return {
      internalCurrentPage: this.currentPage,
      internalPageSize: this.calcPageSize(this.pageSizes),
      internalPageCount: 0
    };
  },
  created: function created() {
    this.calcPageSize();
    this.calcPageCount(this.internalPageSize);
  },
  methods: {
    calcPageSize: function calcPageSize(pageSizes) {
      if (!pageSizes || !pageSizes.length) {
        return 0;
      }

      return pageSizes.includes(this.pageSize) ? this.pageSize : pageSizes[0];
    },
    onPrevClick: function onPrevClick() {
      this.internalCurrentPage--;
      this.emitChange();
    },
    onNextClick: function onNextClick() {
      this.internalCurrentPage++;
      this.emitChange();
    },
    onPageChange: function onPageChange(page) {
      this.internalCurrentPage = page;
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('page-change', this.internalCurrentPage, this.internalPageSize);
    },
    onSizesChange: function onSizesChange(size) {
      this.internalPageSize = size;
      this.$emit('size-change', 1, size);
    },
    calcPageCount: function calcPageCount(size) {
      if (typeof this.total === 'number' && size !== 0) {
        this.internalPageCount = Math.max(1, Math.ceil(this.total / size));
      }

      if (typeof this.pageCount === 'number') {
        this.internalPageCount = Math.max(1, this.pageCount);
      } // init current page


      this.internalCurrentPage = this.currentPage;
      return 0;
    },
    onJumpToPage: function onJumpToPage(page) {
      this.internalCurrentPage = Math.min(page, this.internalPageCount);
      this.emitChange();
    },
    renderPegination: function renderPegination(contentLocale) {
      var h = this.$createElement;
      return h("div", {
        "class": external_classnames_default()('meg-pagination', {
          'meg-pagination-small': this.size === 'small'
        })
      }, [h("prev", {
        attrs: {
          disabled: this.disabled || this.internalCurrentPage <= 1
        },
        on: {
          "click": this.onPrevClick
        }
      }), h("pagers", {
        attrs: {
          disabled: this.disabled,
          "current-page": this.internalCurrentPage,
          "page-count": this.internalPageCount,
          "pager-count": this.pagerCount
        },
        on: {
          "page-change": this.onPageChange
        }
      }), h("next", {
        on: {
          "click": this.onNextClick
        },
        attrs: {
          disabled: this.disabled || this.internalCurrentPage >= this.internalPageCount || this.internalPageCount === 0
        }
      }), this.showTotal && !!this.total && h(total, {
        attrs: {
          disabled: this.disabled,
          total: this.total,
          contentLocale: contentLocale
        }
      }), this.showSizes && h("sizes", {
        attrs: {
          disabled: this.disabled,
          "page-sizes": this.pageSizes,
          "page-size": this.internalPageSize,
          contentLocale: contentLocale
        },
        on: {
          "change": this.onSizesChange
        }
      }), this.showJumper && h("jumper", {
        attrs: {
          disabled: this.disabled,
          contentLocale: contentLocale
        },
        on: {
          "ok": this.onJumpToPage
        }
      })]);
    }
  },
  watch: {
    total: function total() {
      this.calcPageCount(this.internalPageSize);
    },
    pageCount: function pageCount() {
      this.calcPageCount(this.internalPageSize);
    },
    pageSize: function pageSize(val) {
      this.internalPageSize = val;
    },
    currentPage: function currentPage(val) {
      this.internalCurrentPage = val;
    },
    internalPageSize: function internalPageSize(val) {
      this.calcPageCount(val);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(LocaleReceiver["a" /* default */], {
      attrs: {
        componentName: "Pegination"
      },
      scopedSlots: {
        default: this.renderPegination
      }
    });
  },
  components: {
    Prev: prev,
    Next: next,
    Pagers: pagination_pagers,
    Sizes: sizes,
    Jumper: jumper,
    Total: total
  }
};
/* harmony default export */ var pagination = (MegPagination);
// CONCATENATED MODULE: ./src/components/pagination/index.jsx


pagination.install = function (Vue) {
  Vue.component(pagination.name, pagination);
};

/* harmony default export */ var components_pagination = __webpack_exports__["default"] = (pagination);

/***/ })

}]);